<template>
    <vs-switch v-model="themeStatus">
        <template #off>
            🌙
        </template>
        <template #on>
            ☀️
        </template>
    </vs-switch>
</template>
<script>
    export default {
        name: 'home',
        data() {
            return {
                themeStatus:false
            };
        },
        watch: {
            themeStatus(val) {
                if (val) {
                    console.log('light')
                    this.setTheme('light-theme')
                }else{
                    this.setTheme('dark-theme')
                    console.log('dark')
                }
            }
        },
        mounted() {
            this.getTheme()
        },
        methods: {
            setTheme(theme) {
                localStorage.setItem("user-theme", theme);
                // document.documentElement.className = theme;
                if (theme === "light-theme") {
                    this.themeStatus = true
                    document.documentElement.setAttribute("data-theme", "light");
                    /*If required*/
                    document.body.classList.add("light-mode");
                    document.body.classList.remove("dark-mode");
                } else {
                    this.themeStatus = false
                    document.documentElement.setAttribute("data-theme", "dark");
                    /*If required*/
                    document.body.classList.add("dark-mode");
                    document.body.classList.remove("light-mode");
                }
            },
            getTheme() {
                const activeTheme = localStorage.getItem("user-theme");

                if (activeTheme === "light-theme") {
                    this.themeStatus = true
                    document.documentElement.setAttribute("data-theme", "light");
                    /*If required*/
                    document.body.classList.add("light-mode");
                    document.body.classList.remove("dark-mode");
                } else {
                    this.themeStatus = false
                    document.documentElement.setAttribute("data-theme", "dark");
                    /*If required*/
                    document.body.classList.add("dark-mode");
                    document.body.classList.remove("light-mode");
                }
            },
        },

    }
</script>